import { module } from 'modujs';
import Env from '../base/env';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
  }

  anim(e) {
    if (e.mode == 'enter' && e.direction == 'down') {
      Env.$html.classList.add('footer-inview');
    } else {
      Env.$html.classList.remove('footer-inview');
    }
  }
}
